import { Link } from 'react-router-dom';
import { webtoons } from '@/mocks/webtoons';

export default function FeaturedSection() {
  const featured = webtoons.filter((w) => w.featured);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-950">
            热门推荐
          </h2>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {featured.map((webtoon) => (
            <Link
              key={webtoon.id}
              to={`/article/${webtoon.id}`}
              className="group cursor-pointer"
              data-product-shop
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-200">
                <img
                  src={webtoon.cover}
                  alt={webtoon.title}
                  title={`在线韩漫 ${webtoon.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                    {webtoon.rating}
                  </span>
                </div>
                <div className="absolute top-2 right-2">
                  <span className={`px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${
                    webtoon.status === '连载中'
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-secondary-500 text-background-50'
                  }`}>
                    {webtoon.status}
                  </span>
                </div>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                {webtoon.title}
              </h3>
              <p className="text-xs text-foreground-600 mt-1">{webtoon.author}</p>
              <p className="text-xs text-foreground-500 mt-0.5">
                <i className="ri-eye-line mr-1"></i>{webtoon.views}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}